import { IEsimPackage } from "../../interfaces/esim/EsimPackages.types";

interface PackageSelectorProps {
  packages: IEsimPackage[];
  selectedPackage: IEsimPackage | null;
  onPackageSelect: (packageItem: IEsimPackage | null) => void;
  loading?: boolean;
  disabled?: boolean;
}

const formatPackageName = (pkg: IEsimPackage): string => {
  if (pkg.isUnlimited) {
    return `${pkg.name} • ${pkg.validityDays} ditë • Unlimited`;
  }
  return `${pkg.name} • ${pkg.totalGB}GB • ${pkg.validityDays} ditë`;
};

export const PackageSelector: React.FC<PackageSelectorProps> = ({
  packages,
  selectedPackage,
  onPackageSelect,
  loading = false,
  disabled = false
}) => {
  return (
    <div className="relative w-full">
      <div className="relative">
        <select
          value={selectedPackage?.id || ""}
          onChange={(e) => {
            const packageId = e.target.value;
            if (packageId) {
              const pkg = packages.find((p) => p.id === Number(packageId));
              onPackageSelect(pkg || null);
            } else {
              onPackageSelect(null);
            }
          }}
          disabled={disabled || loading || packages.length === 0}
          className="w-full p-2 border border-gray-300 rounded-lg
            focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white
            disabled:bg-gray-100 disabled:cursor-not-allowed"
        >
          <option value="">
            {disabled ? "Zgjedh zonën fillimisht" : "Të gjitha paketat"}
          </option>
          {packages.map((pkg) => (
            <option key={pkg.id} value={pkg.id}>
              {formatPackageName(pkg)}
            </option>
          ))}
        </select>
        {loading && (
          <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
          </div>
        )}
      </div>
    </div>
  );
};
